// extracted by mini-css-extract-plugin
export default {"sidebar":"Nav_sidebar__46K+M","logo":"Nav_logo__Hmf5A","scrollBox":"Nav_scrollBox__h+9Sx","links":"Nav_links__kz6xA","active":"Nav_active__scGYq"};